import api, { apiError } from "../lib/api";
import { audioFilename, voiceUploadError } from "../lib/audio";
import { useI18n } from "../lib/i18n";
import VoiceRecorder from "./VoiceRecorder";

export default function PlayerVoiceRequest({ context, contextTitle, requestId, onSent, ...recorderProps }) {
  const { t } = useI18n();
  const send = async (blob, duration, mimeType, captured) => {
    const form = new FormData();
    form.append("audio", blob, audioFilename("voice-request", mimeType)); form.append("duration", String(duration));
    const target = captured?.requestId; const selectedContext = captured?.context;
    if (!target && selectedContext) {
      form.append("context_type", selectedContext.type || "other");
      if (selectedContext.id) form.append("context_id", selectedContext.id);
      if (selectedContext.title) form.append("context_title", selectedContext.title);
    }
    let result;
    try {
      const { data } = await api.post(
        target ? `/me/requests/${target}/audio` : "/me/requests/audio", form,
      );
      result = data.request;
    } catch (err) {
      if (!err.response || err.response.status >= 500) throw new Error(t("voiceUploadNotConfirmed"));
      throw new Error(voiceUploadError(err, t, apiError(err.response?.data?.detail)));
    }
    // Refresh failures after accepted upload must never trigger a second POST.
    try { await onSent?.(result); } catch (_) { /* Accepted request remains in the request list. */ }
  };
  return <VoiceRecorder {...recorderProps} gesture onSend={send} contextTitle={contextTitle || context?.title}
    binding={{ requestId, context, displayTitle: contextTitle || context?.title }} />;
}
